export default "__VITE_ASSET__osPwJU51__"